// extracted by mini-css-extract-plugin
module.exports = {"view":"styles_view__3z488","active":"styles_active__2FuUZ"};